var map = {
	"./logo-title.png": 77,
	"./logo-title@2x.png": 13
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 194;



//////////////////
// WEBPACK FOOTER
// ./themes/mf/img ^\.\/logo\-title.*\.png$
// module id = 194
// module chunks = 3